import { render, staticRenderFns } from "./bullDamsYieldWiseSemenStorage.vue?vue&type=template&id=48cb3660&scoped=true&"
import script from "./bullDamsYieldWiseSemenStorage.vue?vue&type=script&lang=js&"
export * from "./bullDamsYieldWiseSemenStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cb3660",
  null
  
)

export default component.exports